import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

import { useReveal } from 'modules/Room/Hooks/useReveal';
import { GameStatusEnum } from 'modules/Room/game-status/constants/game-status-enum';
import { useGameStatusStore } from 'modules/Room/game-status/store/game-status-store';

import { MovesEnum, RoomStatusEnum, RoundStagesEnum } from 'shared/constants/shared-enums';
import { useAccount } from 'shared/hooks/use-web3';
import { usePlayerGamesStore } from 'shared/store/playerGamesStore';
import { useRoomStore } from 'shared/store/roomStore';

const useRevealLogic = () => {
  const { playMoves } = usePlayerGamesStore();
  const { activeRoomId } = useParams();
  const { roundStage, roundCounter, roomStatus, playerA, roundMoves, roomExpire } = useRoomStore();
  const { address, chainId } = useAccount();
  const { revealGameStatus } = useGameStatusStore();
  const { writeReveal } = useReveal();
  const amIPlayerA = playerA?.address.toLowerCase() === address?.toLowerCase();
  const { setGameStatus } = useGameStatusStore();
  const revealedRef = useRef<string | null>(null);
  useEffect(() => {
    const key = `${activeRoomId}-${address}-${chainId}-${roundCounter}`;
    if (revealedRef.current === key) return;
    const isReadyForReveal =
      roundStage === RoundStagesEnum.RevealMove && roomStatus === RoomStatusEnum.ReadyForReveal;
    const isPlayerMoveNone =
      ((amIPlayerA && roundMoves.playerA.move === MovesEnum.None) ||
        (!amIPlayerA && roundMoves.playerB.move === MovesEnum.None)) &&
      playMoves[activeRoomId! + address + chainId + roundCounter];
    const isReadyForRevealCondition = isReadyForReveal && isPlayerMoveNone;
    if (
      isReadyForRevealCondition &&
      !playMoves[activeRoomId! + address + chainId + roundCounter]?.revealHash?.hash &&
      !roomExpire
    ) {
      revealedRef.current = key;
      console.log('we are ready for reveal');
      setTimeout(() => {
        console.log('call reveal');
        writeReveal();
        setGameStatus(GameStatusEnum.WAIT_YOUR_REVEAL);
      }, 3000);
    }
  }, [
    roundStage,
    playMoves,
    address,
    roundCounter,
    revealGameStatus,
    setGameStatus,
    roomStatus,
    roundMoves,
    amIPlayerA,
    activeRoomId,
    chainId,
  ]);
};

export default useRevealLogic;
